module.exports = (function() {
	AOS.init({
		duration: 1200,
		delay: 0,
		easing: "ease",
		once: true
	});
	
	//RELLAX
	if ($('[data-rellax]').length) {
		rellax = new Rellax('[data-rellax]', {round:true});
		
		AddDelayedEventTrigger(600, 'resize', function() {
			rellax.refresh();
		});
	}
})();